import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { PAYMENTS, PAYMENT_FAQ, SETTINGS_FINANCIAL } from '../constants/routes';
import Loader from './Loader';
import { selectIsFetchingCreditCards } from '../reducers/auth/auth.selectors';
import FollowBenefits from './FollowBenefits';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectIsFetchingProfile,
  selectIsFollowingProfile,
  selectProfile,
  selectProfileLastActive,
} from '../reducers/profile/profile.selectors';
import { fetchProfile, fetchProfileSubs, toggleFollow, sendRedNotification, sendFollowDecide } from '../reducers/profile/profile.actions';
import { BOOKMARKS, LIKEDPOSTS, PURCHASEDPOSTS, ROOT, PROFILE, USER_PROFILE } from '../constants/routes';
import Avatar from '../components/Avatar';
import {

  CloseModalIcon,
} from '../components/Icons';
import { useHistory } from 'react-router-dom';
import _ from 'lodash'
import { CheckIcon } from 'components/Icons';

const AddPaymentModal = ({tipFlow, show, post, onHide, notificationMethod, isSubArray, userDate, notify, notifyUser, user, cardInfo, card, parentCallback, onSubmit }) => {
  const { t } = useTranslation();
  const isFollowingProfile = useSelector(selectIsFollowingProfile);
  const dispatch = useDispatch();
  const location = useLocation();
  const [showPopUp, setShowPopUp] = useState(false);
  const [notifyLoader, setNotifyLoader] = useState(false);
  const history = useHistory();

  const isFetchingCreditCards = useSelector(selectIsFetchingCreditCards);

  useEffect(() => {

    if (show) {
      document.body.style.top = `-${window.scrollY}px`
      document.body.style.position = 'fixed'
      document.querySelector('html').style.height = `${window.innerHeight - 1}px`;
    }
    else {
      document.querySelector('html').style.height = '';
      document.body.style.position = ''
      document.body.style.top = ''
    }

    return removeStyles;
  }, [])

  let newDate = new Date(userDate?.following_till)
  const removeStyles = () => {
    const scrollY = document.body.style.top
    document.body.style.position = ''
    document.body.style.top = ''
    window.scrollTo(0, parseInt(scrollY || '0') * -1)


  }


  const feedonSubmit = () => {

    dispatch(toggleFollow(post.user.id))


  };
  const cahngeNotiticationStatus = () => {

    setNotifyLoader(true)
    dispatch(sendFollowDecide(notify.data.vendorUser.id, false)).then(resp => {


      dispatch(sendRedNotification(notify.data.vendorUser.id)).then(resp => {

        notificationMethod()
        setNotifyLoader(false)
        onHide()
      })

    })



  }
  const changeSubscription = () => {



    setNotifyLoader(true)
    dispatch(sendFollowDecide(notify.data.vendorUser.id, true)).then(resp => {


      dispatch(sendRedNotification(notify.data.vendorUser.id)).then(resp => {
        setNotifyLoader(false)
        if (location.pathname.indexOf('/u/') > -1) {
          window.location.reload();
        }
        else {
          notificationMethod()

        }
        onHide()
      })

    }).catch(err => console.log(err))

  }



  return (
    <Modal show={show} id={(isFetchingCreditCards || notifyLoader) && "payment-modal"} onHide={onHide} centered size="md" dialogClassName={notify && notify ? 'notify-payment-modal add-payment-modal-container' : 'add-payment-modal-container'}>      
     <Loader isLoadin={isFetchingCreditCards || notifyLoader} height={160} size={60}>
        {/* <Modal.Header closeButton className={'add-payment-modal-header-container'} style={{ margin: 0, padding: 0 }} /> */}
        <FollowBenefits user={notifyUser ? notifyUser : user} />
        <Modal.Body>
          <div className="user-tip-footer d-flex">
            {notify && notify

              ?
              
             
              <div>
                {

                  !userDate?.following && userDate?.user.subscriptionPrice == null ? <>
                    <div className=" d-flex flex-column justify-content-start" >
                      <p className="payment-modal-content font-weight-bold font-size-14" style={{ color: '#E7EAF3', paddingLeft: '0px' }}> {t('Subscribe to get these benefits')}</p>
                      <div style={{ paddingLeft: '0px' }} className="payment-modal-content-benefits d-flex">
                        <div>
                          <div className="benefit-checks d-flex">
                            <CheckIcon height="24px" width="24px" fill="#27C9FD" />
                            <p className="font-size-12 d-flex align-items-center" style={{ color: '#E7EAF3' }}>{t(`Full access to `)}
                              {userDate?.user.name}{t("'s channel content")}</p>
                          </div>

                          <div className="benefit-checks d-flex">
                            <CheckIcon height="24px" width="24px" fill="#27C9FD" />
                            <p className="font-size-12 d-flex align-items-center" style={{ color: '#E7EAF3' }}>{t(`Full acces to all interactions in `)} {userDate?.user.name} {t("'s channel")}</p>
                          </div>
                        </div>
                      </div>


                      <Link
                        className="btn mt-3 mb-3 mx-auto text-grey font-weight-bold"
                        style={{ borderRadius: '32px', width: '100%', fontFamily: '    font-family: "Inter", sans-serif', backgroundColor: '#A9B3D3' }}
                        onClick={changeSubscription}

                      >
                        {t('Subscribe for free')}

                      </Link>
                    </div>
                  </> :
                    <div className="d-flex flex-column justify-content-start" >
                      <p className="payment-modal-content font-weight-bold font-size-14" style={{ color: '#E7EAF3' }}> {t('Subscription change')}</p>
                      <div className="d-flex">
                        <div>
                          <div className="user-posibilities d-flex">
                            <p className="font-size-12 d-flex align-items-center ml-1" style={{ color: '#E7EAF3' }}>
                              This artist has changed his subscription payment, from <span className="old-price"> {notify.data.vendorUser.oldPrice}₪  </span>to <span className="new-price">{userDate?.following ? notify.data.vendorUser.newPrice : userDate?.user.subscriptionPrice}₪ </span> in order for you to keep following him you first need to confirm the new payment
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className={'payment-user-date'}>
                        {userDate?.following_till == undefined ? <>your subscription is expired</> : <>                    your subscription plan will expire from the date {userDate.following_till ? <span>{newDate.toDateString().split(' ').slice(1, -1).join(' ')},<span style={{ paddingLeft: '4px' }}>{newDate.getFullYear()}</span></span> : 0}
                        </>}
                      </div>
                      {notify.data.vendorUser.newPrice != 0 ?

                        <Link
                          className="btn mt-3 mb-3 mx-auto text-grey font-weight-bold"
                          style={{ borderRadius: '32px', width: '100%', fontFamily: '    font-family: "Inter", sans-serif', backgroundColor: '#A9B3D3' }}
                          onClick={changeSubscription}

                        >
                          {t('Subscribe')}     <span className="currency-icon">₪{userDate?.following ? notify.data.vendorUser.newPrice : userDate?.user.subscriptionPrice}</span> {t('per month')}
                        </Link>
                        : <Link
                          className="btn mt-3 mb-3 mx-auto text-grey font-weight-bold"
                          style={{ borderRadius: '32px', width: '100%', fontFamily: '    font-family: "Inter", sans-serif', backgroundColor: '#A9B3D3' }}
                          onClick={changeSubscription}

                        >
                          {t('Subscribe for free')}

                        </Link>}
                    </div>


                }

              </div> :
              (card && card.length == 0 ?

                <Link
                  className="btn mt-3 mb-3 mx-auto text-grey font-weight-bold"
                  style={{ borderRadius: '32px', width: '100%', fontFamily: '    font-family: "Inter", sans-serif', backgroundColor: '#A9B3D3' }}
                  onClick={removeStyles}
                  to={{
                    pathname: PAYMENTS,
                    state:  {user,tipFlow,tipId:post && post.id}
                  }}
                >
                  {t('Please add a payment card')}
                </Link>
                : (
                  user && user.subscriptionPrice != null ?

                    <div
                      className="btn mt-3 mb-3 mx-auto text-grey font-weight-bold"
                      style={{ borderRadius: '32px', width: '100%', fontFamily: '    font-family: "Inter", sans-serif', backgroundColor: '#E7EAF3' }}
                      onClick={location.pathname == ROOT ? feedonSubmit : onSubmit}
                    >
                      {t('Subscribe')}     <span className="currency-icon">₪{user && user.subscriptionPrice}</span> {t('per month')}
                    </div>
                    : <div
                      className="btn mt-3 mb-3 mx-auto text-grey font-weight-bold"
                      style={{ borderRadius: '32px', width: '100%', fontFamily: '    font-family: "Inter", sans-serif', backgroundColor: '#E7EAF3' }}
                      onClick={location.pathname == ROOT ? feedonSubmit : onSubmit}

                    >
                      {t('Subscribe for free')}

                    </div>
                )
              )}

          </div>
        </Modal.Body>
        <div className="modal-payment-footer">
          {
            notify && notify ?
              <button onClick={() => cahngeNotiticationStatus()} className="btn modal-payment-footer-btn">{t('Cancel')}</button>


              :
              <button onClick={onHide} className="btn modal-payment-footer-btn">{t('Close')}</button>

          }
        </div>
      </Loader>
    </Modal>
  );
};

export default AddPaymentModal;
